export default function mathJaxRender() {
  setTimeout(() => {
    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
  }, 10);
}
